import { render, staticRenderFns } from "./PartialInfoCredentials.vue?vue&type=template&id=ce4fe552&"
import script from "./PartialInfoCredentials.vue?vue&type=script&lang=ts&"
export * from "./PartialInfoCredentials.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports